import { Component, OnInit, ViewChild, Output, EventEmitter } from '@angular/core';
import { ModalComponent } from '@app/shared/components';
import { ToolScanTreeComponent } from '@app/tool/components';
import { OperationTools } from '@app/tool/model/operation-tools.model';
import { OperationType } from '@app/tool/model/operationType.model';
import { TranslateService } from '@ngx-translate/core';
import {TicketType} from "@models/enums/ticket-type.enum";

@Component({
  selector: 'app-operations-for-return-modal',
  templateUrl: './operations-for-return-modal.component.html',
  styleUrls: ['./operations-for-return-modal.component.scss']
})
export class OperationsForReturnModalComponent implements OnInit {

  @ViewChild(ModalComponent, {static: true}) modal: ModalComponent;
  @ViewChild(ToolScanTreeComponent, {static: true}) toolScanTree: ToolScanTreeComponent;

  @Output('create') create: EventEmitter<any> = new EventEmitter();

    operationTools: OperationTools[];
    operationsNames: string;
    ticketType: TicketType;

    constructor(private translateService: TranslateService) { }


  ngOnInit() {
  }

  open(data: OperationTools[], ticketType: TicketType) {
    this.operationTools = data || [];
    this.operationsNames = this.translateService.instant('atom.existing-operations.text',
        {operations: this.operationTools.map(x => x.operationName).join(",")});
    this.ticketType = ticketType;
    this.modal.open();
  }

  createTicket() {
      const operations = this.operationTools.map(x => new OperationType(
          {id: x.operationId, name: x.operationName, inUse: false, priority: 0}))
      this.create.emit( {operations, ticketType: this.ticketType });
      this.modal.close();
  }

  getOperationTitle(name: string) {
      return this.translateService.instant('atom.existing-operations.operationTitle',
          {operation: name});
  }

   isOpen() {
        return this.modal.isOpen();
    }

}
